import { JamfSettingsState } from './types';

export const INITIAL_STATE: () => JamfSettingsState = () => {
  return {
    credentials: {
      view: 'read',
    },
  };
};
